import { useState, useEffect } from "react";
import { Link } from "gatsby";
const Menubar = ({ whatsInIt, howToJoin, joinNow }) => {
    const [open, setOpen] = useState(false);
    const [a, setA] = useState("");
    const [b, setB] = useState("");
    const [c, setC] = useState("");

    const handleDropdown = () => {
        setOpen(!open);
    };

    useEffect(() => {
        if (open) {
            setA("a");
            setB("b");
            setC("c");
        } else {
            setA("");
            setB("");
            setC("");
        }
    }, [open]);

    return (
        <div className="headerWrapper gcwmenu">
            <header
                className="header_area header_stick nav-black brad48"
                id="headerarea"
            >
                <div className="my-lg-auto px-lg-3 container mx-auto">
                    <div className="row">
                        <div className="col-10 col-lg-2 my-auto text-center">
                            <a
                                href="/global-corporate-virtual-walkathon/"
                                className="navbar-brand sticky_logo"
                            >
                                <img
                                    width="210"
                                    height="45"
                                    className="d_logo site-logo"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                                    alt=""
                                />

                                <img
                                    width="180"
                                    height="27"
                                    alt="Vantage Fit"
                                    className="stick_logo"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                                    data-loaded="true"
                                />
                            </a>
                        </div>
                        <div className="col-8 row d-none d-lg-flex justify-content-end align-items-center">
                            <Link className="nvlink mr-5" to={whatsInIt}>
                                What's in it?
                            </Link>
                            <Link className="nvlink mr-5" to={howToJoin}>
                                How to Join?
                            </Link>
                            <Link
                                className="nvlink mr-5"
                                to="/contest-guidelines-global-corporate-virtual-walkathon/"
                            >
                                Contest Guidelines
                            </Link>
                            <Link
                                className="nvlink"
                                to="/about-us-global-corporate-virtual-walkathon/"
                            >
                                About Us
                            </Link>
                            {/* <ul className='list-unstyled mb-0'>
                            <li className="listingMenu" id="homepage-features-section">
                                <a className="site-nav-item p-0 text-white" href="#">Previous Events
                                <svg style={{'height': '20px', 'width': '20px'}} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                                </a>
                                <ul className="dropdownmenu">
                                    <li><a className="site-nav-item " href="/global-corporate-virtual-walkathon-2022/">GCW 2022</a></li>
                                    <li><a className="site-nav-item " href="/global-corporate-virtual-walkathon-2021/">GCW 2021</a></li>
                                </ul>
                            </li>
                        </ul> */}
                            {/* <a className='text-white' href='/leaderboard/'>Leaderboard</a> */}
                        </div>
                        <div className="col-1 hidden d-lg-flex justify-content-end mt-2 text-white">
                            {/* <div className="mr-2 my-auto">
                            <div className="mb-1 pull-left"><a href="/global-corporate-virtual-walkathon/#gcwHubspotForm" className="text-white nav-menu-btn pull-left">REGISTER</a></div>
                            <div className="text-center" style={{'fontSize' : '12px'}}>New User</div>
                        </div> */}
                            <div className="nvlink">
                                <div className="mb-1 pull-left">
                                    <a
                                        href="https://vantagefit.vantagecircle.com/"
                                        className="nav-btn-ghost pull-left"
                                    >
                                        LOGIN
                                    </a>
                                </div>
                                <div
                                    className="text-center"
                                    style={{ fontSize: "12px" }}
                                >
                                    Existing User
                                </div>
                            </div>
                        </div>
                        <div
                            className="col-2 d-flex d-lg-none align-items-center justify-content-end"
                            onClick={handleDropdown}
                        >
                            {/* <a href='' className='text-white' style={{ backgroundColor: '#FBECEC', borderRadius: '50%', padding: '8px 10px' }}><span className='navbar-toggler-icon'></span></a> */}
                            <a
                                href=""
                                className="text-white d-flex flex-column justify-content-center align-items-center"
                                style={{
                                    backgroundColor: "#FBECEC",
                                    borderRadius: "50%",
                                    padding: "8px 10px",
                                    height: "45px",
                                    width: "45px",
                                }}
                            >
                                <div className="icon-1" id={a}></div>
                                <div className="icon-2" id={b}></div>
                                <div className="icon-3" id={c}></div>
                            </a>
                        </div>
                    </div>
                </div>
            </header>
            <div
                className={
                    open
                        ? "dropdownActive gcwmobile-menu bg-white pt-2 d-flex flex-column overflow-x-hidden pb-5"
                        : "dropdown overflow-hidden h-0"
                }
            >
                <div
                    className="text-dark"
                    onClick={handleDropdown}
                    style={{ borderBottom: "1px solid #fadcdc" }}
                >
                    <a
                        href={whatsInIt}
                        className="pull-left col-12 px-3 py-3 text-dark w-100"
                        style={{ float: "left" }}
                    >
                        What's in it?
                    </a>
                </div>
                <div
                    className="text-dark"
                    onClick={handleDropdown}
                    style={{ borderBottom: "1px solid #fadcdc" }}
                >
                    <a
                        href={howToJoin}
                        className="pull-left col-12 px-3 py-3 text-dark w-100"
                        style={{ float: "left" }}
                    >
                        How to Join?
                    </a>
                </div>
                <div
                    className="text-dark"
                    style={{ borderBottom: "1px solid #fadcdc" }}
                >
                    <a
                        href="/contest-guidelines-global-corporate-virtual-walkathon/"
                        className="pull-left col-12 px-3 py-3 text-dark w-100"
                        style={{ float: "left" }}
                    >
                        Contest Guidelines
                    </a>
                </div>
                <div
                    className="text-dark"
                    style={{ borderBottom: "1px solid #fadcdc" }}
                >
                    <a
                        href="/about-us-global-corporate-virtual-walkathon/"
                        className="pull-left col-12 px-3 py-3 text-dark w-100"
                        style={{ float: "left" }}
                    >
                        About Us
                    </a>
                </div>
                {/* <div className='text-dark' style= {{ borderBottom: '1px solid #fadcdc'}}><a href="/global-corporate-virtual-walkathon-2022/" className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>GCW 2022</a></div>
                <div className='text-dark' style= {{ borderBottom: '1px solid #fadcdc'}}><a href="/global-corporate-virtual-walkathon-2021" className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>GCW 2021</a></div> */}
                {/* <div className='text-dark border-bottom'><a href="/leaderboard/" className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Leaderboard</a></div> */}
                <div className="text-dark d-flex w-100 pt-3 px-3">
                    <a
                        onClick={() => setOpen(false)}
                        href="/global-corporate-virtual-walkathon/#gcwHubspotForm"
                        className="pull-left px-3 py-2 w-50 text-center text-white font-weight-bold rounded nav-menu-btn"
                        style={{ float: "left" }}
                    >
                        Register
                    </a>
                </div>
                <div className="text-dark d-flex w-100 pt-3 px-3">
                    <a
                        href="https://vantagefit.vantagecircle.com/"
                        className="pull-left px-3 py-2 w-50 text-center font-weight-bold rounded nav-color-ghost"
                        style={{ float: "left" }}
                    >
                        Login
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Menubar;
